import type { PropsWithChildren } from "react";

import type { FlexAlignType } from "react-native";

import { FloatingButtonWrapperTestID } from "@/constants/TestID";
import { Box } from "@/ui/layout";
import { isWeb } from "@/utils/platform.util";

interface FloatingButtonWrapperProps extends PropsWithChildren {
  alignSelf?: FlexAlignType;
  isViewportFixed?: boolean;
  opacity?: number;
  paddingBottom?: number;
  right?: number;
}

const FloatingButtonWrapper = ({
  alignSelf = "center",
  children,
  isViewportFixed = false,
  opacity,
  paddingBottom,
  right,
}: FloatingButtonWrapperProps) => {
  // on web, ScreenContainer has a fixed max width (does not fill the screen), but
  // some floating buttons should be viewport-relative not ScreenContainer-relative.
  // "fixed" is valid CSS on web but absent from RN's position union (Box's prop type),
  // so set position via style in both cases to keep a single source of truth for it.
  const style = {
    position:
      isWeb() && isViewportFixed ? ("fixed" as const) : ("absolute" as const),
  };

  return (
    <Box
      alignSelf={alignSelf}
      bottom={20}
      opacity={opacity}
      paddingBottom={paddingBottom}
      right={right}
      style={style}
      testID={FloatingButtonWrapperTestID.Wrapper}
    >
      {children}
    </Box>
  );
};

export type { FloatingButtonWrapperProps };
export default FloatingButtonWrapper;
